import React, { FormEvent, useMemo, useState } from "react";

function defaultRedirect() {
  return "https://app.stealthos.xyz/app";
}

export default function AppAccessLoginPage() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const next = useMemo(() => {
    if (typeof window === "undefined") return defaultRedirect();
    const params = new URLSearchParams(window.location.search);
    return params.get("next") || defaultRedirect();
  }, []);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    setIsSubmitting(true);
    try {
      const response = await fetch("/api/app-access/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password, next }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data?.error || "Access denied");
        return;
      }
      window.location.assign(data?.redirectTo || defaultRedirect());
    } catch {
      setError("Access unavailable");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <main className="app-access">
      <a href="/" className="app-access-brand" aria-label="StealthOS home">
        <img
          src="/stealthOS_logo-removebg-preview.png"
          alt="StealthOS"
          className="app-access-logo"
        />
      </a>
      <form className="app-access-panel" onSubmit={handleSubmit}>
        <h1>App Access</h1>
        <label className="app-access-label" htmlFor="app-access-password">
          Password
        </label>
        <input
          id="app-access-password"
          className="app-access-input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          autoFocus
        />
        <button
          className="lp-btn lp-btn-primary app-access-submit"
          type="submit"
          disabled={!password || isSubmitting}
        >
          {isSubmitting ? "Unlocking..." : "Continue"}
        </button>
        <p className="app-access-error" role="status" aria-live="polite">
          {error}
        </p>
      </form>
      <p className="app-access-alt">
        No access yet? <a href="/waitlist">Join the waitlist</a>
      </p>
    </main>
  );
}
